import Vue from 'vue'
import VueRouter from 'vue-router'
import Title from '@/views/Title.vue'
import Guidelines from '@/views/Guidelines.vue'
import SceneOrder from '@/views/SceneOrder.vue'
import SceneView from '@/views/SceneView.vue'
import Credits from '@/views/Credits.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'What Happened Here',
    component: Title,
  },
  {
    path: '/guidelines',
    name: 'Guidelines',
    component: Guidelines,
  },
  {
    path: '/trackchoice',
    name: 'Track Choice',
    component: SceneOrder,
  },
  {
    path: '/scene/:id',
    name: 'Scene',
    component: SceneView,
  },
  {
    path: '/credits',
    name: 'Credits',
    component: Credits,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
